import { BusinessFlow } from '../types/diagram.types';

export const BUSINESS_FLOWS: BusinessFlow[] = [
  // ── Профиль и Аутентификация ─────────────────────────────────────
  {
    id: 'flow-registration',
    name: 'Регистрация',
    color: '#2196F3',
    type: 'mixed',
    group: 'Профиль и Аутентификация',
    description: 'Регистрация нового пользователя через мобильное приложение',
    edgeIds: [
      'e-mobile-apigw', 'e-apigw-users', 'e-users-accounts-create',
      'e-users-user-reg-pub', 'e-user-reg-notif-sub',
      'e-notifications-sender', 'e-sender-sendgrid',
    ],
  },
  {
    id: 'flow-auth',
    name: 'Авторизация',
    color: '#1565C0',
    type: 'synchronous',
    group: 'Профиль и Аутентификация',
    description: 'Вход пользователя по логину и паролю (JWT)',
    edgeIds: ['e-mobile-apigw', 'e-apigw-users'],
  },
  {
    id: 'flow-2fa',
    name: '2FA верификация',
    color: '#283593',
    type: 'mixed',
    group: 'Профиль и Аутентификация',
    description: 'Подтверждение входа через SMS/Email OTP',
    edgeIds: [
      'e-mobile-apigw', 'e-apigw-users',
      'e-users-user-reg-pub', 'e-user-reg-notif-sub',
      'e-notifications-sender', 'e-sender-sendgrid', 'e-sender-twilio',
    ],
  },
  {
    id: 'flow-pin-setup',
    name: 'Установка PIN-кода',
    color: '#5C6BC0',
    type: 'synchronous',
    group: 'Профиль и Аутентификация',
    description: 'Создание или обновление PIN-кода пользователя',
    edgeIds: ['e-mobile-apigw', 'e-apigw-users'],
  },
  {
    id: 'flow-password-recovery',
    name: 'Восстановление пароля',
    color: '#7986CB',
    type: 'mixed',
    group: 'Профиль и Аутентификация',
    description: 'Сброс пароля через Email/SMS ссылку',
    edgeIds: [
      'e-mobile-apigw', 'e-apigw-users',
      'e-users-user-reg-pub', 'e-user-reg-notif-sub',
      'e-notifications-sender', 'e-sender-sendgrid',
    ],
  },
  {
    id: 'flow-kyc',
    name: 'KYC Верификация',
    color: '#F44336',
    type: 'mixed',
    group: 'Профиль и Аутентификация',
    description: 'Верификация документов пользователя оператором',
    edgeIds: [
      'e-mobile-apigw', 'e-apigw-kyc', 'e-kyc-s3',
      'e-kyc-scoring', 'e-scoring-kyc-prov',
      'e-adminpanel-adminapi', 'e-adminapi-kyc',
      'e-kyc-users-status', 'e-kyc-kyc-approved-pub', 'e-kyc-approved-notif-sub',
    ],
  },

  // ── Управление Счётом ────────────────────────────────────────────
  {
    id: 'flow-account-open',
    name: 'Открытие счёта',
    color: '#43A047',
    type: 'synchronous',
    group: 'Управление Счётом',
    description: 'Открытие нового счёта после регистрации',
    edgeIds: ['e-mobile-apigw', 'e-apigw-users', 'e-users-accounts-create'],
  },
  {
    id: 'flow-card-deposit',
    name: 'Пополнение картой (3DS)',
    color: '#4CAF50',
    type: 'mixed',
    group: 'Управление Счётом',
    description: 'Пополнение счёта банковской картой через PSP Fenige',
    edgeIds: [
      'e-mobile-apigw', 'e-apigw-acq-gw', 'e-acq-gw-limiter',
      'e-acq-gw-acq-proc', 'e-acq-proc-fenige', 'e-fenige-fenige-psp',
      'e-fenige-psp-fenige-webhook', 'e-acq-gw-accounts-credit',
    ],
  },
  {
    id: 'flow-sepa-topup',
    name: 'Пополнение SEPA',
    color: '#66BB6A',
    type: 'synchronous',
    group: 'Управление Счётом',
    description: 'Пополнение счёта через SEPA банковский перевод',
    edgeIds: [
      'e-mobile-apigw', 'e-apigw-acq-gw',
      'e-acq-gw-limiter', 'e-acq-gw-accounts-credit',
    ],
  },
  {
    id: 'flow-crypto-deposit',
    name: 'Крипто депозит (BTC)',
    color: '#00BCD4',
    type: 'mixed',
    group: 'Управление Счётом',
    description: 'Получение адреса и зачисление BTC после подтверждений',
    edgeIds: [
      'e-mobile-apigw', 'e-apigw-crypto-acq',
      'e-crypto-acq-crypto-gw', 'e-blockchain-crypto-gw',
      'e-crypto-gw-crypto-acq', 'e-crypto-acq-accounts-credit',
    ],
  },

  // ── Переводы и Платежи ───────────────────────────────────────────
  {
    id: 'flow-quick-exchange',
    name: 'Быстрый обмен (Quote→Confirm)',
    color: '#FF5722',
    type: 'synchronous',
    group: 'Переводы и Платежи',
    description: 'Получение котировки и подтверждение обмена валют',
    edgeIds: [
      'e-mobile-apigw', 'e-apigw-qe', 'e-qe-courses',
      'e-qe-limiter', 'e-qe-accounts',
    ],
  },
  {
    id: 'flow-internal-transfer',
    name: 'Внутренний перевод',
    color: '#FF7043',
    type: 'synchronous',
    group: 'Переводы и Платежи',
    description: 'Перевод средств между счетами внутри системы',
    edgeIds: [
      'e-mobile-apigw', 'e-apigw-qe',
      'e-qe-limiter', 'e-qe-accounts',
    ],
  },
  {
    id: 'flow-card-to-card',
    name: 'Перевод карта-карта',
    color: '#FF8A65',
    type: 'mixed',
    group: 'Переводы и Платежи',
    description: 'Перевод с банковской карты на счёт через PSP',
    edgeIds: [
      'e-mobile-apigw', 'e-apigw-acq-gw', 'e-acq-gw-limiter',
      'e-acq-gw-acq-proc', 'e-acq-proc-fenige', 'e-fenige-fenige-psp',
      'e-fenige-psp-fenige-webhook', 'e-acq-gw-accounts-credit',
    ],
  },
  {
    id: 'flow-google-pay',
    name: 'Google/Apple Pay',
    color: '#FFAB40',
    type: 'mixed',
    group: 'Переводы и Платежи',
    description: 'Пополнение через Google Pay или Apple Pay',
    edgeIds: [
      'e-mobile-apigw', 'e-apigw-acq-gw', 'e-acq-gw-limiter',
      'e-acq-gw-acq-proc', 'e-acq-proc-fenige', 'e-fenige-fenige-psp',
      'e-fenige-psp-fenige-webhook', 'e-acq-gw-accounts-credit',
    ],
  },

  // ── Карты ────────────────────────────────────────────────────────
  {
    id: 'flow-virtual-card',
    name: 'Выпуск виртуальной карты',
    color: '#AB47BC',
    type: 'synchronous',
    group: 'Карты',
    description: 'Выпуск виртуальной банковской карты пользователю',
    edgeIds: ['e-mobile-apigw', 'e-apigw-cards'],
  },
  {
    id: 'flow-plastic-card',
    name: 'Выпуск пластиковой карты',
    color: '#CE93D8',
    type: 'synchronous',
    group: 'Карты',
    description: 'Заказ и выпуск именной пластиковой карты',
    edgeIds: ['e-mobile-apigw', 'e-apigw-cards'],
  },

  // ── Торговля ─────────────────────────────────────────────────────
  {
    id: 'flow-trading',
    name: 'Торговый ордер (Limit)',
    color: '#9C27B0',
    type: 'mixed',
    group: 'Торговля',
    description: 'Создание лимитного ордера, матчинг, исполнение',
    edgeIds: [
      'e-mobile-apigw', 'e-apigw-orders', 'e-orders-orderbook',
      'e-orderbook-matcher', 'e-matcher-orders', 'e-orders-accounts-settle',
      'e-orders-trade-exec-pub', 'e-trade-exec-marketdata-sub',
    ],
  },
  {
    id: 'flow-market-maker',
    name: 'Market Maker Cycle',
    color: '#FF9800',
    type: 'asynchronous',
    group: 'Торговля',
    description: 'Автоматическое перевыставление котировок маркет-мейкером',
    edgeIds: [
      'e-courses-rate-updated-pub', 'e-rate-updated-mm-sub',
      'e-mm-courses', 'e-mm-orderbook',
      'e-orders-mm-filled-pub', 'e-mm-filled-mm-sub',
    ],
  },

  // ── Market Data ──────────────────────────────────────────────────
  {
    id: 'flow-rates',
    name: 'Поток рыночных данных',
    color: '#009688',
    type: 'mixed',
    group: 'Market Data',
    description: 'Обновление курсов от провайдеров до клиентов',
    edgeIds: [
      'e-binance-lp', 'e-lp-courses',
      'e-courses-rate-updated-pub', 'e-rate-updated-mm-sub', 'e-rate-updated-marketdata-sub',
      'e-marketdata-ws-clients',
    ],
  },
];
